const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToParam = require("./util/date-to-param").dateToParam;

const ProductsBestSellersActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] },
  "changeType": {},
  "changeGroup": {}
});

ProductsBestSellersActions.fetchData.listen(function(period, users, funnel, type, group) {
  let params = {
    start_date: dateToParam(period.startDate),
    end_date: dateToParam(period.endDate),
    users: users,
    funnel: funnel,
    type: type,
    group: group
  };

  biAPI.fetch("/product_best_sellers", params, this.completed, this.failed);
});

module.exports = ProductsBestSellersActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/products-best-sellers-actions.js